import api from '../../services/service_process'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      active: 0,
      process_backup: false,
      process_invoice: false,
      process_centrol: false,
      nowdate: this.dateMonth(new Date())
    }
  },
  methods: {
    setActive (int) {
      this.active = int
    },
    processBackup () {
      this.process_backup = true
      api.backUpDB(
        result => {
          if (result.result === false) {
            Swal.fire('ประมวลผล', result.data, 'success')
            this.nowdate = this.dateMonth(new Date())
          } else {
            Swal.fire('ประมวลผล', result.data, 'warning')
          }
          this.process_backup = false
        },
        error => {
          this.process_backup = false
          Swal.fire('ประมวลผล', JSON.stringify(error), 'error')
        }
      )
    },
    processInvoice () {
      Swal.fire({
        title: 'คำเตือน',
        text: 'การประมวลผลใบแจ้งหนี้ประจำเดือน ' + this.monthYearFormat(this.nowdate) + ' อาจจะใช้เวลานานประมาณ 1 ชั่วโมง กรุณาอย่าปิดหน้าต่างโปรแกรมหรือเปลี่ยนเมนู ท่านต้องการดำเนินการต่อหรือไม่ ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.process_invoice = true
          api.invoiceMonth(
            this.header,
            this.dateFormatDMY2(this.nowdate),
            result => {
              if (result.result === false) {
                Swal.fire('ประมวลผล', result.data, 'success')
                this.nowdate = this.dateMonth(new Date())
              } else {
                Swal.fire('ประมวลผล', result.data, 'warning')
              }
              this.process_invoice = false
            },
            error => {
              this.process_invoice = false
              Swal.fire('ประมวลผล', JSON.stringify(error), 'error')
            }
          )
        }
      })
    },
    processCentrol () {
      Swal.fire({
        title: 'คำเตือน',
        text: 'การประมวลผลค่าส่วนกลางประจำเดือน ' + this.monthYearFormat(this.nowdate) + ' อาจจะใช้เวลานานประมาณ 1 ชั่วโมง กรุณาอย่าปิดหน้าต่างโปรแกรมหรือเปลี่ยนเมนู ท่านต้องการดำเนินการต่อหรือไม่ ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.process_centrol = true
          api.CentralinvoiceMonth(
            this.header,
            this.dateFormatDMY2(this.nowdate),
            result => {
              if (result.result === false) {
                Swal.fire('ประมวลผล', result.data, 'success')
                this.nowdate = this.dateMonth(new Date())
              } else {
                Swal.fire('ประมวลผล', result.data, 'warning')
              }
              this.process_centrol = false
            },
            error => {
              this.process_centrol = false
              Swal.fire('ประมวลผล', JSON.stringify(error), 'error')
            }
          )
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/process.js